import { Button } from '@/swell-ui/Button'
import { useSwellWeb3 } from '@/swell-web3/core'
import styled from 'styled-components'

export const StyledButtonThin = styled(Button)`
  width: 100%;
  height: unset;
  color: var(--white-50, #fff);
  /* Body/medium bold */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%; /* 25.6px */
  padding: 8px 16px;
`

export function ConnectWalletButton() {
  const { connect } = useSwellWeb3()
  return (
    <StyledButtonThin onClick={() => connect()}>
      Connect Wallet
    </StyledButtonThin>
  )
}

export function ClaimWavedropButton() {
  return <StyledButtonThin disabled>Claim</StyledButtonThin>
}
